<div style="padding: 24px;">
  <h3 mat-dialog-title class="text-center">Eliminar Ciudad / Delete City</h3>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <label mat-dialog-title class="text-center mt-6 mb-6">Está seguro de eliminar la ciudad? / Are you sure to remove the City?</label>
  </div>
  <div mat-dialog-actions>
    <button mat-button  mat-dialog-close (click)="onNoClick(false)">Cancelar / Cancel</button>
    <button mat-button cdkFocusInitial (click)="submit()">Delete / Delete</button>
  </div>
</div>
